import React from 'react'
import LazyLoad from 'react-lazyload'

// Define the VideoWithOverlay component
const VideoWithOverlay = () => {
  return (
    <div className="relative w-full h-auto">
      <LazyLoad height={200} offset={100} once>
        {/* Video element */}
        <video
          className="px-4 py-4 absolute inset-0 w-full h-full object-cover shadow-4xl"
          style={{ borderRadius: '50px' }}
          autoPlay
          playsInline
          loop
          muted
          preload="metadata" // Preload video metadata
          src="/static/ptp-site-video.webm"
        >
          <source src="/static/ptp-site-video.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </LazyLoad>
      {/* Overlay image with lazy loading */}
      <img
        src="/static/device.webp"
        alt="Device Frame"
        className="relative w-full h-full object-contain"
        loading="lazy" // Lazy load image
      />
    </div>
  )
}

export default VideoWithOverlay
